import { ajaxActions } from 'common/ajax/store.js';
import { basePath } from 'common/config.js';

const ADD_PHONE_CONTACT = 'ADD_PHONE_CONTACT';
const RECEIVED_ADDRESS_REGION = 'RECEIVED_ADDRESS_REGION';
const UPDATE_CURRENT_ADDRESS = 'UPDATE_CURRENT_ADDRESS';
const UPDATE_CURRENT_EMAIL_ADDRESS = 'UPDATE_CURRENT_EMAIL_ADDRESS';
const UPDATE_CURRENT_EMERGENCY = 'UPDATE_CURRENT_EMERGENCY';
const UPDATE_CURRENT_PHONE_CONTACT = 'UPDATE_CURRENT_PHONE_CONTACT';
const RECEIVED_ACCOUNT_DETAILS = 'RECEIVED_ACCOUNT_DETAILS';
const RESET_ADDRESS_REGIONS = 'RESET_ADDRESS_REGIONS';

const initialState = {
  regions: null,
};

export const actionCreators = {
  createPhoneContact: (adfitNo, model) => async (dispatch) => {
    let url = `${basePath}/api/accounts/${adfitNo}/phonenumbers`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'POST',
        (result) => {
          dispatch({ type: ADD_PHONE_CONTACT, result: result });
        },
        model,
        true
      )
    );
  },
  getAccountDetails: (adfitNo) => async (dispatch) => {
    let url = `${basePath}/api/accounts/${adfitNo}/details`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'GET',
        (result) => {
          dispatch({ type: RECEIVED_ACCOUNT_DETAILS, result: result });
        },
        null,
        true
      )
    );
  },
  getAddressRegion: (countryCode) => async (dispatch) => {
    let url = `${basePath}/api/Regions?countryCode=${countryCode}`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'GET',
        (result) => {
          dispatch({ type: RECEIVED_ADDRESS_REGION, result: result });
        },
        null,
        false
      )
    );
  },
  updateCurrentAddress: (adfitNo, addressId, model) => async (dispatch) => {
    let url = `${basePath}/api/accounts/${adfitNo}/addresses/${addressId}`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'PUT',
        (result) => {
          dispatch({ type: UPDATE_CURRENT_ADDRESS, result: result });
        },
        model,
        true
      )
    );
  },
  updateCurrentEmailAddress: (adfitNo, emailAddressId, model) => async (
    dispatch
  ) => {
    let url = `${basePath}/api/accounts/${adfitNo}/emailaddresses/${emailAddressId}`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'PUT',
        (result) => {
          dispatch({ type: UPDATE_CURRENT_EMAIL_ADDRESS, result: result });
        },
        model,
        true
      )
    );
  },
  updateCurrentEmergency: (adfitNo, phoneNumberId, model) => async (
    dispatch
  ) => {
    let url = `${basePath}/api/accounts/${adfitNo}/phonenumbers/${phoneNumberId}`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'PUT',
        (result) => {
          dispatch({ type: UPDATE_CURRENT_EMERGENCY, result: result });
        },
        model,
        true
      )
    );
  },
  updateCurrentPhoneContact: (adfitNo, phoneNumberId, model) => async (
    dispatch
  ) => {
    let url = `${basePath}/api/accounts/${adfitNo}/phonenumbers/${phoneNumberId}`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'PUT',
        (result) => {
          dispatch({ type: UPDATE_CURRENT_PHONE_CONTACT, result: result });
        },
        model,
        true
      )
    );
  },

  resetAddressRegions: () => {
    return { type: RESET_ADDRESS_REGIONS };
  },
};

export const reducer = (state = initialState, action) => {
  state = state || initialState;
  if (action.type === RECEIVED_ACCOUNT_DETAILS) {
    return {
      ...state,
      ...action.result,
    };
  } else if (action.type === RECEIVED_ADDRESS_REGION) {
    return {
      ...state,
      regions: action.result,
    };
  } else if (action.type === UPDATE_CURRENT_ADDRESS) {
    return {
      ...state,
      addresses: state.addresses.map((address) =>
        address.addressNo === action.result.addressId
          ? {
              ...address,
              streetNumber: action.result.addressLine1,
              street: action.result.addressLine2,
              suburb: action.result.suburb,
              city: action.result.city,
              state: action.result.state,
              postcode: action.result.postcode,
            }
          : address
      ),
    };
  } else if (action.type === UPDATE_CURRENT_EMAIL_ADDRESS) {
    return {
      ...state,
      emailAddresses: state.emailAddresses.map((c) =>
        c.id === action.result.emailAddressId
          ? {
              ...c,
              preferred: action.result.isPrimary,
            }
          : c
      ),
    };
  } else if (action.type === UPDATE_CURRENT_EMERGENCY) {
    return {
      ...state,
      emergencyContacts: state.emergencyContacts.map((c) =>
        c.id === action.result.phoneNumberId
          ? {
              ...c,
              contactName: action.result.phoneName,
              countryCode: action.result.countryCode,
              number: action.result.phoneNumber,
            }
          : c
      ),
    };
  } else if (action.type === UPDATE_CURRENT_PHONE_CONTACT) {
    return {
      ...state,
      phoneNumbers: state.phoneNumbers.map((c) =>
        c.id === action.result.phoneNumberId
          ? {
              ...c,
              name: action.result.phoneName,
              countryCode: action.result.countryCode,
              number: action.result.phoneNumber,
              preferred: action.result.isPrimary,
            }
          : c
      ),
    };
  } else if (action.type === ADD_PHONE_CONTACT) {
    return {
      ...state,
      phoneNumbers: [
        ...state.phoneNumbers,
        {
          id: action.result.phoneNumberId,
          countryCode: action.result.countryCode,
          number: action.result.phoneNumber,
          type: action.result.phoneType,
          name: action.result.phoneName,
          preferred: action.result.isPrimary,
        },
      ],
    };
  } else if (action.type === RESET_ADDRESS_REGIONS) {
    return {
      ...state,
      regions: null,
    };
  }

  return state;
};
